module.exports = __webpack_public_path__ + "static/media/candy.b6c9c86d.svg";